import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AcceptAllProposal,
  DeclineContractProposal,
} from "../../../../../redux/job/action";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storage } from "../../../../../Firebase/config";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import html2canvas from "html2canvas";
import { Modal } from "reactstrap";
import PopupContractPrivacyPolicy from "../../../../Common/PopupContractPrivacyPolicy";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import { takeAndUploadScreenshot } from "../../../../../utils/takeAndUploadScreenshot";
import SignContractInput from "../../../../Common/SignContractInput";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";

const SignJobContract = ({ pbi }) => {
  const { setManageAppliedprojectroute } = useRouteBaseStateContext();

  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const { state } = location;
  const [modal, setModal] = useState(null);

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const formik = useFormik({
    initialValues: {
      first_name: profile?.first_name,
      last_name: profile?.last_name,
      agree: false,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      agree: Yup.boolean().oneOf([true], "You must agree to the terms"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
                // const screenshotUrl = await takeAndUploadScreenshot();
        const screenshotUrl = "image.png"
        if (screenshotUrl) {
          hireexpert(screenshotUrl, values);
        } else {
          setLoading(false);
          console.error("Failed to upload screenshot. Please try again.");
        }
      } catch (error) {
        console.error("Error taking or uploading screenshot:", error);
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (profile) {
      formik.setFieldValue('first_name', profile?.first_name);
      formik.setFieldValue('last_name', profile?.last_name);
    }
  }, [profile])

  const hireexpert = (screenshotUrl, values) => {
    if (state?.approvefrom == "user") {
      const state = {
        id: pbi?.id,
        milestone_id: pbi?.milestones[0]?.id,
        milestone_amount: pbi?.milestones[0]?.amount,
        type: 1,
        type_of_post: "project",
        post_id: pbi?.post_id,
        post_price: pbi?.milestones[0]?.amount || pbi?.milestones[0]?.post_price || pbi?.post_price,
        proposal_id: id,
      };

      const data = {
        ...values,
        type: "1",
        id: pbi?.id,
        status: "5",
        image: screenshotUrl,
        url: `/${lan}/dashboard/managework/projects`,
        state: state,
      };

      dispatch(AcceptAllProposal(data, setLoading, navigate));
    } else {
      const state = {
        id: pbi?.id,
        milestone_id: pbi?.milestones[0]?.id,
        milestone_amount: pbi?.milestones[0]?.amount,
        type: 1,
        type_of_post: "project",
        post_id: pbi?.post_id,
        // post_price: pbi?.post_price,
        post_price: pbi?.milestones[0]?.amount || pbi?.milestones[0]?.post_price || pbi?.post_price,
        proposal_id: id,
      };

      const data = {
        ...values,
        type: "1",
        id: pbi?.id,
        status: "3",
        image: screenshotUrl,
        url: `/${lan}/account/paymentmethodpage`,
        state: state,
      };

      dispatch(AcceptAllProposal(data, setLoading, navigate));
    }
  };

  const hitthismethod = () => {
    navigate(-1);
  };

  const hitthismethod1 = () => {
    setManageAppliedprojectroute("ProjectDetails");
    navigate(-1);
  };

  const DeclineContract = () => {
    if (state?.owner) {
      const data = {
        type: "1",
        id: pbi?.id,
        status: "2",
      };
      dispatch(DeclineContractProposal(data, setLoading, hitthismethod));
    } else {
      const data = {
        type: "1",
        id: id,
        status: "4",
      };
      dispatch(DeclineContractProposal(data, setLoading, hitthismethod1));
    }
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <SignContractInput formik={formik} />

        <div className="checkbox">
          <input
            type="checkbox"
            id="agree"
            name="agree"
            checked={formik.values.agree}
            onClick={() => {
              if (!formik.values.agree) {
                setModal(true);
              }
              else {
                formik.setFieldValue("agree", !formik.values.agree);
              }
            }}
          />
          <label htmlFor="agree">
            Yes, I understand and agree to Urxprt’s {' '}
            <span>{' '} Terms of Service</span>, including the
            <span>{' '} User Agreement</span> and <span>Privacy Policy</span>.
          </label>
          {formik.touched.agree && formik.errors.agree ? (
            <div className="error">{formik.errors.agree}</div>
          ) : null}
        </div>

        <div id='dont-take-this-in-screenshot' >
          <div className="submit-btn">
            <button
              onClick={() => {
                DeclineContract();
              }}
              disabled={loading}
              type="button"
              className="btn"
            >
              {loading ? <LoginLoaderButton /> : "Decline contract"}
            </button>
            <button type="submit" className="btn post-btn" disabled={loading}>
              {loading
                ? <LoginLoaderButton />
                : state?.approvefrom
                  ? "Accept & Start project"
                  : "Accept"}
            </button>
          </div>
        </div>
      </form>
      {modal && (
        <Modal
          isOpen={modal}
          keyboard={false}
          className="modal-width modal-centered popupmodal termsconditionmodal"
        >
          <PopupContractPrivacyPolicy formik={formik} setModal={setModal} />
        </Modal>
      )}
    </>
  );
};

export default SignJobContract;
